























import { UserStateModule } from '@/store';
import { CreateElement, VNode } from 'vue';
import { Component, Vue } from 'vue-property-decorator';

@Component<NavigationItems>({})
export default class NavigationItems extends Vue {
  // FIELDS
  navigationItems = [
    { name: 'feeds', title: 'HOME' },
    { name: 'search', title: 'SEARCH' },
    { name: 'post', title: 'POST' },
    {
      name: 'activity',
      title: 'ACTIVITY',
    },
  ];
  UserStateModule = UserStateModule;

  // MUTATIONS
  get getClassObj() {
    return (navigationItem: NavigationItem) => {
      const classObj: any = {};
      classObj[navigationItem.class] = true;
      classObj['is-current'] = this.$route.name === navigationItem.name;
      return classObj;
    };
  }
  get myAvatarSrc(): string {
    return this.UserStateModule.myImage;
  }
}

interface NavigationItem {
  name: string;
  class: string;
  title: string;
}
